import { render, staticRenderFns } from "./ConfiguratorMain.vue?vue&type=template&id=09622190&"
import script from "./ConfiguratorMain.vue?vue&type=script&lang=js&"
export * from "./ConfiguratorMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports